<app-document-subheader />

@let workLocation = this.workLocation$ | async;

<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (workLocation) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">

                <div class="row mb-2">
                  <div class="col-12 col-md-9 mr-auto">
                    <div class="form-group">
                      <label class="form-title-label" translate>WORK_LOCATION_LBL_NAME</label>
                      <div class="form-title">{{ workLocation.name }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>WORK_LOCATION_LBL_TYPE</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          @if (workLocation.typeLoc == null) {
                            -
                          } @else {
                            {{ workLocation.typeLoc }}
                          }
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>WORK_LOCATION_LBL_SALES_TEAM</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          @if (workLocation.salesTeamId == null) {
                            -
                          } @else {
                            <app-link-to
                              [id]="workLocation.salesTeamId.toString()"
                              [label]="workLocation.salesTeamName"
                              [url]="'/Crm/SalesTeams/Details/'"
                            />
                          }
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>WORK_LOCATION_LBL_COUNTED_AS_WORK</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          <input type="checkbox" [checked]="workLocation.countedAsWork" disabled />
                        </span>
                      </div>
                    </div>

                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>WORK_LOCATION_LBL_ACTIVE</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          <input type="checkbox" [checked]="workLocation.active" disabled />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (workLocation) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'WorkLocation'"
          [entityId]="workLocation.id.toString()"
        />
      </div>
    }
  </div>
</div>
